import React from 'react';
import { Nav } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';

const SideMenuLink = ({ title, icon: Icon, path }) => {
  // Generate test ID from title (e.g., "Dashboard" -> "dashboard-link")
  const testId = `${title.toLowerCase().replace(/\s+/g, '-')}-link`;

  return (
    <Nav.Link as={NavLink} to={path} eventKey={path} data-testid={testId}>
      <span className="pe-3">
        <Icon />
      </span>
      <span>{title}</span>
    </Nav.Link>
  );
};

export default SideMenuLink;
